module.exports = __webpack_public_path__ + "static/media/playstore.13b5be33.svg";